import React from "react";
import { playerIsStalled } from "../playerHelpers/playerCoreUtils";

const PlayerWrapper = ({
  videoWrapperRef,
  mouseEventHandler,
  videoControlsKeyUp,
  handleVolume,
  playerMgr,
  onClickToggleState,
  children,
}) => {
  return (
    <div
      ref={videoWrapperRef}
      onMouseMove={mouseEventHandler}
      onMouseDown={mouseEventHandler}
      onMouseLeave={mouseEventHandler}
      onKeyUp={videoControlsKeyUp}
      onKeyDown={handleVolume}
      id="videoWrapper"
      onClick={!playerIsStalled(playerMgr) ? onClickToggleState : undefined}
      tabIndex="0"
      className="video-wrapper"
    >
      {children}
    </div>
  );
};

export default PlayerWrapper;
